module.exports = __webpack_public_path__ + "static/interstate-bold-condensed-5540b56665105881fc0d6e91ffed7c59.otf";